import { Builder } from '@builder.io/react';
import Banner from './Banner';

Builder.registerComponent(Banner, {
  name: 'HomepageBanner',
  inputs: [
    {
      name: 'bannerImage',
      type: 'object',
      defaultValue: {
        alt: 'the banner image',
      },
      subFields: [
        {
          name: 'image',
          type: 'file',
          allowedFileTypes: ['jpeg', 'png', 'gif', 'svg'],
        },
        {
          name: 'alt',
          type: 'string',
        },
      ],
    },
    {
      name: 'logo',
      type: 'file',
      allowedFileTypes: ['svg'],
    },
    {
      name: 'textColour',
      type: 'color',
    },
    {
      name: 'smallTitle',
      type: 'string',
      defaultValue: '2024',
    },
    {
      name: 'subtitle',
      type: 'richText',
      defaultValue: 'London and San Francisco',
    },
    {
      name: 'buttonText',
      type: 'string',
      defaultValue: 'Buy Tickets',
    },
    {
      name: 'linkTo',
      type: 'string',
      defaultValue: '/',
      helperText: 'Set the URL the button will link to',
    },
  ],
});

